import { Outlet } from "react-router-dom";
import ToggleButton from "./ToggleButton";
import "./loginStyle.css";
import { useState } from "react";
import Login from "./Login";
import Register from "./Register";

const Layout = ({ setIsLoggedIn }) => {
  const [selected, setSelected] = useState("login");
  return (
    <div className="auth-layout light">
      <ToggleButton selected={selected} setSelected={setSelected} />
      <div>
        {selected === "login" ? (
          <Login setIsLoggedIn={setIsLoggedIn} />
        ) : (
          <Register setIsLoggedIn={setIsLoggedIn} />
        )}
      </div>
    </div>
  );
};

export default Layout;
